export default __webpack_public_path__ + "assets/illustrations/trophy_graphic.933e46466a246ecb1a0c04e087d68b1c.png";